// ProvidersPage duck — minimal, all content is static marketing
const initialState = {};

export default function reducer(state = initialState, action: any = {}) {
  return state;
}

export const loadData = () => () => Promise.resolve();
